function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function HeadphoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.125V7.63929C3.75 4.86997 6.1005 2.625 9 2.625C11.8995 2.625 14.25 4.86997 14.25 7.63929V10.125",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125 12C1.125 10.7574 2.13236 9.75 3.375 9.75H5.25C5.66421 9.75 6 10.0858 6 10.5V15C6 15.4142 5.66421 15.75 5.25 15.75H3.375C2.13236 15.75 1.125 14.7426 1.125 13.5V12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 13.5C16.875 14.7426 15.8676 15.75 14.625 15.75L12.75 15.75C12.3358 15.75 12 15.4142 12 15L12 10.5C12 10.0858 12.3358 9.75 12.75 9.75L14.625 9.75C15.8676 9.75 16.875 10.7574 16.875 12L16.875 13.5Z",
    fill: "currentColor"
  }));
}
export default HeadphoneIcon;
//# sourceMappingURL=Headphone.js.map